module.exports = __webpack_public_path__ + "img/icon_loop_selected.4760e88f.png";